import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        pathName: "",
        currDbSource: {},
        currJobData: {},
        DbSource: [],
        infoManageMessageNum: 0,
        ordersItemMessageNum: 0,
        waitMakeMessageNum: 0,
        waitSendMessageNum: 0
    },
    mutations:{
        // 保存当前菜单栏的路径
        savePath(state,pathName){
            state.pathName = pathName;
        },
        // 保存当前点击的数据源
        saveCurrDbSource(state,currDbSource){
            state.currDbSource = currDbSource;
        },
        // 保存当前点击的元数据
        saveCurrJobData(state,currJobData){
            state.currJobData = currJobData;
        },
        // 保存所有数据源
        saveDbSource(state,DbSource){
            state.DbSource = DbSource;
        },
        saveInfoManageMessageNum(state,infoManageMessageNum){
            state.infoManageMessageNum = infoManageMessageNum;
        },
        saveOrdersItemMessageNum(state,ordersItemMessageNum){
            state.ordersItemMessageNum = ordersItemMessageNum;
        },
        saveWaitMakeMessageNum(state,waitMakeMessageNum){
            state.waitMakeMessageNum = waitMakeMessageNum;
        },
        saveWaitSendMessageNum(state,waitSendMessageNum){
            state.waitSendMessageNum = waitSendMessageNum;
        },
    }
})